import React, { Fragment, useEffect, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import '../Style/Comunication.css';



function Comunication() {
  const [first, setfirst] = useState(true)

  useEffect(() => {
    setInterval(setfirst(false), 2000);
  },[first])

  return (
    <Fragment> 
        <div className='comunicationGeneral'>
            <div className='whatsupStyle whatsupPosition' >
                <a href="https://api.whatsapp.com/send?phone=905322005989" target='_blank'><WhatsAppIcon className='whatsupWhatsup'/></a>
            </div>
        </div> 
    </Fragment>
      

  )
}

export default Comunication;